import { ReporteriaVideoPanel } from '@/components/videos/ReporteriaVideoPanel'

export function HomeVideoPanel({ variant = 'default' }: { variant?: 'default' | 'home' }) {
  return (
    <ReporteriaVideoPanel
      title={variant === 'home' ? 'Entrevistas candidatos' : 'Reportería ciudadana'}
      variant={variant}
    />
  )
}
